import React, { useState } from "react";
import SpecialSiteDetails from "./SpecialSiteDetails";
import FilterData from "./FilterData";

const SpecialSite = () => {
  const [open, setOpen] = useState<boolean>(false);

  const handleClick = (): void => {
    setOpen(true);
  };
  const handleFilterChange = () => {
    setOpen(false);
  };
  return (
    <div className="content-wrapper">
      <h1 className="flex align-items-center">
        Special Site
      </h1>
      <FilterData handleClick={handleClick} handleFilterChange={handleFilterChange}/>
      {open && <SpecialSiteDetails />}
    </div>
  );
};

export default SpecialSite;
